var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseOrder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 67 67",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.565 64.583h39.626a6.228 6.228 0 0 0 6.226-6.226v-.048a6.225 6.225 0 0 0-6.226-6.226h-2.108V10.399a8.316 8.316 0 0 0-8.315-8.316H8.333c-1.15 0-2.083.933-2.083 2.084v52.101a8.315 8.315 0 0 0 8.315 8.315zm39.626-4.166H18.75v-2.108a2.06 2.06 0 0 1 2.059-2.059h33.382a2.06 2.06 0 0 1 2.059 2.059v.048a2.06 2.06 0 0 1-2.059 2.06zm-6.274-8.334V10.399a4.149 4.149 0 0 0-4.149-4.149H10.417v50.018a4.149 4.149 0 0 0 4.148 4.149h.018V58.31a6.225 6.225 0 0 1 6.226-6.227zM16.667 31.25h12.5a2.085 2.085 0 0 0 2.083-2.083c0-1.15-.934-2.084-2.083-2.084h-12.5c-1.15 0-2.084.934-2.084 2.084 0 1.149.934 2.083 2.084 2.083zm0-8.333h25a2.085 2.085 0 0 0 2.083-2.084 2.085 2.085 0 0 0-2.083-2.083h-25c-1.15 0-2.084.934-2.084 2.083 0 1.15.934 2.084 2.084 2.084zm0-8.334h25a2.084 2.084 0 0 0 0-4.166h-25c-1.15 0-2.084.933-2.084 2.083s.934 2.083 2.084 2.083z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrder);
export default __webpack_public_path__ + "static/media/purchase-order.515234777507f3c402bc82382e234a16.svg";
export { ForwardRef as ReactComponent };